import { ThemeProvider as EmotionThemeProvider } from "@emotion/react";
import { DEFAULT_THEME } from "@material-dev/insights-portal-ui-components/lib/feature-components/m-app";
import { Theme as MuiTheme, ThemeProvider as MuiThemeProvider, createTheme } from "@mui/material/styles";
import React, { PropsWithChildren } from "react";

declare module "@emotion/react" {
  // eslint-disable-next-line @typescript-eslint/no-empty-interface
  interface Theme extends MuiTheme {}
}
// @ts-ignore
const theme = createTheme(DEFAULT_THEME);
const ThemeProvider: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    <EmotionThemeProvider theme={theme as never}>
      <MuiThemeProvider theme={theme}>{children}</MuiThemeProvider>
    </EmotionThemeProvider>
  );
};

export default ThemeProvider;
